import { LinearProgress } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { fetchMyData } from '../api/mobileapi';
import { PersonalData } from '../api/types';
import { GlobalError } from '../components/GlobalError/GlobalError';
import { useHomeData } from '../components/LoadHomeData/HomeDataProvider';
import { MyData } from '../components/MyData/MyData';
import { useTranslations } from '../components/Translations/TranslationsProvider';
import { AdamsError } from '../utils/errors';

export const MyDataPage = () => {
    const { translations } = useTranslations();
    const { currentLanguage } = useHomeData();

    const {
        data: personalData,
        isLoading,
        error,
    } = useQuery<PersonalData, AdamsError>(
        ['myData', currentLanguage],
        () => fetchMyData({ language: currentLanguage }),
        {
            enabled: Boolean(currentLanguage),
        }
    );

    if (error) {
        return <GlobalError error={error} translations={translations} />;
    }

    return isLoading || !translations || !personalData ? <LinearProgress /> : <MyData personalData={personalData} />;
};
